import * as React from 'react';
import {useCallback} from 'react';
import {NavLink} from 'react-router-dom';
import {LeftOutlined, RightOutlined} from '@ant-design/icons';
import {Menu} from 'antd';
import Sider from 'antd/es/layout/Sider';
import {observer} from 'mobx-react-lite';
import {AppRoutePaths} from 'routing/Routes';
import {appState} from 'store/AppStore';
import {GarageDto, UserRole} from '../../../../../PRMGApiClient';
import {adminSidebarNavigation, getNavigationItem, sidebarNavigation} from './navigation';

export interface SidebarProps {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

export const Sidebar: React.FC<SidebarProps> = observer(({collapsed, setCollapsed}) => {
  const [siderWidth, setSiderWidth] = React.useState(72);
  const navigationItems = !appState.commonData?.user?.roles?.includes(UserRole.Admin)
    ? adminSidebarNavigation
    : sidebarNavigation;

  const getNavItems = useCallback(
    (garages: GarageDto[]) =>
      navigationItems.map(({title, url, Icon, children}) =>
        getNavigationItem(
          url === AppRoutePaths.services.url ? title : <NavLink to={url}>{title}</NavLink>,
          title,
          <Icon />,
          url === AppRoutePaths.garages.url
            ? garages.map((garage) =>
                getNavigationItem(<NavLink to={url + `/${garage.id}`}>{garage.name}</NavLink>, String(garage.id))
              )
            : children?.map(({title, url}) => getNavigationItem(<NavLink to={url}>{title}</NavLink>, url))
        )
      ),
    []
  );

  return (
    <Sider
      breakpoint="md"
      className="left-side-bar"
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      collapsedWidth={siderWidth}
      width={210}
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        zIndex: 1,
        height: '100vh',
        paddingTop: '4rem',
        background: '#fff',
      }}
      trigger={<div className="bg-[#fafafa] text-black">{collapsed ? <RightOutlined /> : <LeftOutlined />}</div>}
      onBreakpoint={(broken) => broken && setSiderWidth(0)}
      zeroWidthTriggerStyle={{display: 'none'}}
    >
      <Menu
        mode="inline"
        style={{height: '100%', display: 'flex', flexDirection: 'column'}}
        className="h-full br-0"
        items={getNavItems(appState.garages)}
      />
    </Sider>
  );
});
